import React from "react";
import { FaTwitter, FaTelegramPlane, FaDiscord } from "react-icons/fa";
import { SiMedium } from "react-icons/si";

export default function Footer() {
  return (
    <footer className="w-full bg-black px-4 py-6 text-white">
      <div className="mx-auto max-w-[1380px]">
        <div className="grid grid-cols-1 gap-8 border-b border-white/5 pb-6 md:grid-cols-4">

          {/* Logo */}
          <div>
            <img
              src="/etherai.png"
              alt="Ethra AI"
              className="mb-5 h-[92px] w-auto object-contain"
            />

            <p className="text-[15px] leading-7 tracking-wide text-gray-300">
              AI-POWERED TRADING.
              <br />
              REAL REVENUE. REAL VALUE.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-5 text-[16px] font-semibold uppercase text-gray-200">
              QUICK LINKS
            </h3>

            <div className="grid grid-cols-2 gap-x-12 gap-y-3 text-[14px] text-gray-300">
              <a href="#home" className="hover:text-[#c4dc5b]">Home</a>
              <a href="#roadmap" className="hover:text-[#c4dc5b]">Roadmap</a>
              <a href="#about" className="hover:text-[#c4dc5b]">About</a>
              <a href="#faqs" className="hover:text-[#c4dc5b]">FAQs</a>
              <a href="#tokenomics" className="hover:text-[#c4dc5b]">Tokenomics</a>
              <a href="#contact" className="hover:text-[#c4dc5b]">Contact</a>
            </div>
          </div>

          {/* Follow */}
          <div>
  <h3 className="mb-5 text-[16px] font-semibold uppercase text-gray-200">
    FOLLOW US
  </h3>

  <div className="flex items-center gap-5">
    <a
      href="https://x.com/ethra_ai?s=11"
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-[44px] w-[44px] items-center justify-center rounded-full border-2 border-[#9ac40b] text-[#9ac40b] transition hover:bg-[#9ac40b] hover:text-black"
    >
      <FaTwitter className="text-[22px]" />
    </a>

    <a
      href="https://t.me/ethraaiofficial"
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-[44px] w-[44px] items-center justify-center rounded-full border-2 border-[#9ac40b] text-[#9ac40b] transition hover:bg-[#9ac40b] hover:text-black"
    >
      <FaTelegramPlane className="text-[22px]" />
    </a>
  </div>
</div>

          {/* Disclaimer */}
          <div>
            <h3 className="mb-5 text-[16px] font-semibold uppercase text-gray-200">
              DISCLAIMER
            </h3>

            <p className="max-w-[260px] text-[14px] leading-7 text-gray-300">
              Crypto investments are subject to market risks. Please do your own
              research before investing.
            </p>
          </div>
        </div>

        <div className="pt-4 text-center text-[14px] text-gray-400">
          © 2024 Ethra AI. All rights reserved.
        </div>
      </div>
    </footer>
  );
}